import {createStyles} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const PurchaseHistoryListOrganizationStyle = () =>
  createStyles({
    statusWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 30,
      marginBottom: 20,
    },
    paymentWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: 30,
    },
    paymentTitle: {
      fontSize: 16,
      color: '#676a6c',
      fontWeight: 500,
    },
    paymentButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: 5,
    },
    paymentButton: {
      padding: '6px 16px',
      backgroundColor: '#0cc7c780',
      fontSize: 14,
      borderRadius: 4,
      color: 'white',
      height: 36.5,
    },
    paymentButtonActive: {
      backgroundColor: '#0cc7c7',
    },

    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      marginTop: '15px',
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
      marginBottom: 20,
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    headerMax: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
    },
    agencyWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 30,
      marginTop: 20,
    },
    agencyCardWrapper: {
      flex: 1,
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 10,
    },
    agencyCard: {
      padding: '5px 10px',
      minWidth: 220,
      height: '100%',
      background: 'white',
      border: '2px solid #e0e0e0',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      animation: 'fadeInUp 0.6s ease-out',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 5,
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        background: 'linear-gradient(45deg, #0cc7c7, #17a2b8, #0cc7c7)',
        borderRadius: '14px',
        zIndex: '-1',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover::before': {
        opacity: 0.1,
      },
    },
    agencyCardActive: {
      borderColor: '#0cc7c7 !important',
      background: '#e2ffff !important',
    },
  })

export default PurchaseHistoryListOrganizationStyle
